let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("03pGU")).then(() => parcelRequire('sRlqV'));